import React, { useEffect, useState } from 'react';
import AssignedAppsPanel from './AssignedAppsPanel';
import LgDeviceAppEditor from '../Settings/LgDeviceAppEditor';
import { syncNativeAppServices } from './assignedAppApi';
import { assignedAppMessage } from './assignedAppPresentation';

export default function LgEpgAppsTab({ device }) {
  const [reload, setReload] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editing, setEditing] = useState(false);
  const [busy, setBusy] = useState(false);
  const [dirty, setDirty] = useState(false);
  useEffect(() => {
    let active = true;
    setLoading(true); setError('');
    syncNativeAppServices(device.id).then(() => { if (active) setLoading(false); })
      .catch((failure) => { if (active) { setError(assignedAppMessage(failure)); setLoading(false); } });
    return () => { active = false; };
  }, [device.id, reload]);
  return <div className="dashboard-app-launcher">
    <div className="dashboard-app-launcher-header">
      <div><h3>LG TV app services</h3><p>Selected apps with supported programme guides appear below. Configure a service, test its channel controls and confirm the picture before using EPG Watch Now.</p></div>
      <div className="dashboard-app-launcher-actions">
        <button type="button" className="secondary" disabled={loading || busy || dirty} onClick={() => setEditing(true)}>Choose TV Apps</button>
        <button type="button" className="secondary" disabled={loading || busy || dirty} onClick={() => setReload((value) => value + 1)}>Refresh detected services</button>
      </div>
    </div>
    {loading && <p role="status">Matching selected TV apps to supported services…</p>}
    {error && <p role="alert">{error}</p>}
    {!loading && !error && <AssignedAppsPanel key={`${device.id}:${reload}`} deviceId={device.id}
      nativeConnector="lg_webos_remote" nativeEpg onBusyChange={setBusy} onDirtyChange={setDirty} />}
    {editing && <LgDeviceAppEditor key={device.id} device={device} onClose={() => setEditing(false)}
      onSaved={() => setReload((value) => value + 1)} />}
  </div>;
}
